<template>
  <div
    class="theme-h3"
    :class="{
      'theme-h3__grow': grow,
      'theme-h3__primary': color === 'primary',
    }"
  >
    <slot></slot>
  </div>
</template>

<script setup>
defineProps({
  grow: { type: Boolean, default: false },
  color: { type: String, default: '' },
})
</script>

<style lang="scss" scoped>
.theme-h3 {
  font-size: $text-2xl;
  font-weight: $font-semibold;
  line-height: 1.166667;
}
.theme-h3__grow {
  @media (min-width: $breakpoint-m) {
    font-size: $text-4xl;
  }
}
.theme-h3__primary {
  color: $brand-primary;
}
</style>
